var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24C17 24 16.15 23.65 15.45 22.95C14.75 22.25 14.4 21.4 14.4 20.4C14.4 20.26 14.41 20.1148 14.43 19.9644C14.45 19.814 14.48 19.6792 14.52 19.56L6.06 14.64C5.72 14.94 5.34 15.1752 4.92 15.3456C4.5 15.516 4.06 15.6008 3.6 15.6C2.6 15.6 1.75 15.25 1.05 14.55C0.35 13.85 0 13 0 12C0 11 0.35 10.15 1.05 9.45C1.75 8.75 2.6 8.4 3.6 8.4C4.06 8.4 4.5 8.4852 4.92 8.6556C5.34 8.826 5.72 9.0608 6.06 9.36L14.52 4.44C14.48 4.32 14.45 4.1852 14.43 4.0356C14.41 3.886 14.4 3.7408 14.4 3.6C14.4 2.6 14.75 1.75 15.45 1.05C16.15 0.35 17 0 18 0C19 0 19.85 0.35 20.55 1.05C21.25 1.75 21.6 2.6 21.6 3.6C21.6 4.6 21.25 5.45 20.55 6.15C19.85 6.85 19 7.2 18 7.2C17.54 7.2 17.1 7.1152 16.68 6.9456C16.26 6.776 15.88 6.5408 15.54 6.24L7.08 11.16C7.12 11.28 7.15 11.4152 7.17 11.5656C7.19 11.716 7.2 11.8608 7.2 12C7.2 12.1392 7.19 12.2844 7.17 12.4356C7.15 12.5868 7.12 12.7216 7.08 12.84L15.54 17.76C15.88 17.46 16.26 17.2252 16.68 17.0556C17.1 16.886 17.54 16.8008 18 16.8C19 16.8 19.85 17.15 20.55 17.85C21.25 18.55 21.6 19.4 21.6 20.4C21.6 21.4 21.25 22.25 20.55 22.95C19.85 23.65 19 24 18 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c90ecfcd90c5bc9af844c8708a3c16a2.svg";
export { ForwardRef as ReactComponent };